var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 202,
    viewBox: "0 0 199 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_12798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 55.6531C0 27.8265 0 13.9133 5.373 6.95663C10.746 0 21.492 0 42.984 0H156.016C177.508 0 188.254 0 193.627 6.95663C199 13.9133 199 27.8265 199 55.6531V146.347C199 174.173 199 188.087 193.627 195.043C188.254 202 177.508 202 156.016 202H55.8963C34.4043 202 10.746 202 5.373 195.043C0 188.087 0 174.173 0 146.347V55.6531Z",
    fill: "#C9FF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 82H94.5C90.9196 82 87.4858 83.4223 84.9541 85.9541C82.4223 88.4858 81 91.9196 81 95.5V203.5C81 207.08 82.4223 210.514 84.9541 213.046C87.4858 215.578 90.9196 217 94.5 217H256.5C260.08 217 263.514 215.578 266.046 213.046C268.578 210.514 270 207.08 270 203.5V95.5C270 91.9196 268.578 88.4858 266.046 85.9541C263.514 83.4223 260.08 82 256.5 82ZM256.5 176.5H249.75C242.589 176.5 235.722 173.655 230.658 168.592C225.595 163.528 222.75 156.661 222.75 149.5C222.75 142.339 225.595 135.472 230.658 130.408C235.722 125.345 242.589 122.5 249.75 122.5H256.5V176.5ZM94.5 122.5H101.25C108.411 122.5 115.278 125.345 120.342 130.408C125.405 135.472 128.25 142.339 128.25 149.5C128.25 156.661 125.405 163.528 120.342 168.592C115.278 173.655 108.411 176.5 101.25 176.5H94.5V122.5ZM94.5 190H101.25C111.991 190 122.293 185.733 129.888 178.138C137.483 170.543 141.75 160.241 141.75 149.5C141.75 138.759 137.483 128.457 129.888 120.862C122.293 113.267 111.991 109 101.25 109H94.5V95.5H168.75V203.5H94.5V190ZM256.5 203.5H182.25V95.5H256.5V109H249.75C239.009 109 228.707 113.267 221.112 120.862C213.517 128.457 209.25 138.759 209.25 149.5C209.25 160.241 213.517 170.543 221.112 178.138C228.707 185.733 239.009 190 249.75 190H256.5V203.5Z",
    fill: "white",
    fillOpacity: 0.45
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_12798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 202,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.f76cec4adf0eaf0d5fafcb9d1181bd59.svg";
export { ForwardRef as ReactComponent };